// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductDetailedPage_container__M5bwp","emptydiv":"ProductDetailedPage_emptydiv__1bAZM"};